<template>
  <div v-if="transaction">
    <user-details :data-user="transaction.source_user" title="Recipient Details" hide-actions />
    <individual-bank-details
      class="mt-5"
      :transaction="transaction"
      :payment="transaction.payin"
      :owner="transaction.source_user"
    />

    <cashin-details :dataTransaction="transaction" class="mt-5" />
    <suspicion-case :transaction="transaction" class="mt-5" />
    <blockchain-transaction :transaction="transaction" />
    <!-- <cashout-documents :cashout.sync="transaction" class="mt-3" /> -->
  </div>
</template>
<script>
import UserDetails from "@/app/users/detail";
import IndividualBankDetails from "@/app/accounts/bankaccounts/IndividualBankDetails";
import CashinDetails from "./details";
import BlockchainTransaction from "../transfers/blockchaintransactions.vue";
import SuspicionCase from "./suspicionCase.vue";

export default {
  components: {
    UserDetails,
    CashinDetails,
    IndividualBankDetails,
    BlockchainTransaction,
    SuspicionCase,
  },
  props: {
    id: { required: true },
  },
  data: () => ({
    transaction: undefined,
  }),

  created() {
    this.$http
      .get(`api/v1/cashin/${this.id}`)
      // eslint-disable-next-line arrow-parens
      .then((data) => {
        this.transaction = data;
      })
      .catch(() => window.Notify.warning("Something went wrong while fetching cashin details"));
  },
};
</script>
